import Vue from 'vue'
import Router from 'vue-router'
import store from '../vuex'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('@/pages/Login')
    },
    {
      path: '/vocabularios',
      name: 'Vocabularios',
      meta: {
        'requiresAuth': true
      },
      component: () => import('@/pages/Vocabulary')
    },
    {
      path: '/vocabulario/:id',
      name: 'Vocabulario',
      meta: {
        'requiresAuth': true
      },
      component: () => import('@/pages/Main')
    },
    {
      path: '/recuperarsenha',
      name: 'Recuperar Senha',
      component: () => import('@/pages/Recoverpass')
    },
    {
      path: '/cadastro',
      name: 'Cadastro',
      component: () => import('@/pages/CreateAccount')
    },
    {
      path: '/teste',
      name: 'teste',
      component: () => import('@/components/phrases/AddPhrase')
    },
    {
      path: '/print/:id',
      name: 'PrintCards',
      meta: {
        'requiresAuth': true
      },
      component: () => import('@/pages/PrintCards')
    }
  ]
})

router.beforeEach((to, from, next) => {
  var protectedRoutes = to.matched.filter(r => {
    return r.meta.requiresAuth
  })

  if (protectedRoutes.length >= 1) {
    (async () => {
      if (store.getters['getUserInfo']) {
        next()
      } else {
        try {
          await store.dispatch('checkLocalInfo')
          next()
        } catch (e) {
          router.push({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        }
      }
    })()
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js